module.exports = __webpack_public_path__ + "img/income.dcead542.png";